import { useFliptBoolean } from 'lib/flipt/hooks';
import { FeatureFlagKeys } from 'lib/flipt/constants/flagKeys';
import useSubAccounts from 'features/multi-porto/hooks/useSubAccounts';

const useLinkedToAdvisor = (): boolean => {
  const { activePortfolio } = useSubAccounts();

  const isEligibleForIfaTransaction = useFliptBoolean(
    FeatureFlagKeys.IFA_TRANSACTION,
  );

  const linkToAdvisor =
    !isEligibleForIfaTransaction &&
    activePortfolio &&
    activePortfolio.is_linked_to_advisor &&
    !activePortfolio.is_main_account;

  return linkToAdvisor;
};
export default useLinkedToAdvisor;
